import { createSlice } from '@reduxjs/toolkit';

export const discoverFiltersSlice = createSlice({
  name: 'discoverFilters',
  initialState: {
    traitIds: [],
    popularityConditions: {},
    filter: 'all',
    rating: 0,
    gender: 'all',
    sort: 'trending',
    country: 'all',
  },

  reducers: {
    setDiscoverPopularityConditions: (state, action) => {
      state.popularityConditions = action.payload;
    },

    setDiscoverFilter: (state, action) => {
      state.filter = action.payload;
    },

    setDiscoverRating: (state, action) => {
      state.rating = action.payload;
    },

    setDiscoverGender: (state, action) => {
      state.gender = action.payload;
    },

    setDiscoverSort: (state, action) => {
      state.sort = action.payload;
    },

    setDiscoverTraitIds: (state, action) => {
      state.traitIds = action.payload;
    },

    setDiscoverCountry: (state, action) => {
      state.country = action.payload;
    },
  },
});

export const {
  setDiscoverPopularityConditions,
  setDiscoverFilter,
  setDiscoverRating,
  setDiscoverGender,
  setDiscoverSort,
  setDiscoverTraitIds,
  setDiscoverCountry,
} = discoverFiltersSlice.actions;

export default discoverFiltersSlice.reducer;
